var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.values(_vm.resultsobj).length>0)?_c('div',{staticClass:"examresultsBox"},[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":_vm.num}},[_c('Examresultsdetail',{attrs:{"resultsobj":_vm.resultsobj}}),_c('Examresultslist',{staticClass:"examresultsBoxtop",attrs:{"resultsobj":_vm.resultsobj}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }